/**
 * Extract a user-facing error message from an axios error or generic Error.
 *
 * Priority order:
 * 1. `err.response.data` if it's a non-empty string (server's plain-text response body)
 * 2. `err.response.data.error` or `err.response.data.message` if it's a JSON object
 * 3. `err.message` (e.g. "Network Error", "Request failed with status code 409")
 * 4. Provided fallback
 */
export function getErrorMessage(err: any, fallback: string = 'An error occurred'): string {
  if (!err) return fallback;

  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }
  if (data && typeof data === 'object') {
    if (typeof data.error === 'string' && data.error.trim()) return data.error.trim();
    if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
    if (typeof data.detail === 'string' && data.detail.trim()) return data.detail.trim();
  }

  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
